import React, {useEffect, useState} from "react";
import {apiV2} from "api/firebase";
import {
  InvalidExhibitorEmailChange,
  SuccessfulExhibitorEmailChange,
} from "view/components/ChangeEmail/NoAccessModals";

function ChangeEmail() {
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");

  useEffect(() => {
    if (!token) {
      console.warn("Missing change email token");
      setStatus("error");
      return;
    }

    const confirmChangeEmail = async () => {
      try {
        await apiV2.exhibitor
          .changeEmailRequestNoAuth({
            token,
            baseURL: import.meta.env.VITE_API_V2_URL as string,
          })
          .handleCallback();
        setStatus("success");
      } catch (err) {
        console.error("Change email failed:", err);
        setStatus("error");
      }
    };

    confirmChangeEmail();
  }, [token]);

  if (status === "error") {
    return <InvalidExhibitorEmailChange />;
  }

  if (status === "success") {
    return <SuccessfulExhibitorEmailChange />;
  }

  return null;
}

export default ChangeEmail;
